export default {
    namespaced: true,
    state: {
        // isClientes : false,
        // isUsuarios : false,
        // isProveedores : false,
        // isPuertos : false,
        // isDestinos : false,
        // isPallets : false,
        // isCondiciones : false,
        // isNaves : false,
        // isNavieras : false,
        // isLimite : false,
        // isTemporadas : false,
        // isEmbarcador : false,
        // isContenedores : false,
        // isDepositos : false,
        // isAtmosferas : false,
        // isTipos : false,
        // isZonas : false,
        // isPaises : false,
        // isRegiones : false,
        // isProvincias : false,
        // isComunas : false,
        // isLocalidades : false,
    },
    mutations: {
        // setIsClientes(state, payload){
        //     state.isClientes = payload;
        // },
        // setIsUsuarios(state, payload){
        //     state.isUsuarios = payload;
        // },
        // setIsProveedores(state, payload){
        //     state.isProveedores = payload;
        // },
        // setIsPuertos(state, payload){
        //     state.isPuertos = payload;
        // },
        // setIsDestinos(state, payload){
        //     state.isDestinos = payload;
        // },
        // setIsPallets(state, payload){
        //     state.isPallets = payload;
        // },
        // setIsCondiciones(state, payload){
        //     state.isCondiciones = payload;
        // },
        // setIsNaves(state, payload){
        //     state.isNaves = payload;
        // },
        // setIsNavieras(state, payload){
        //     state.isNavieras = payload;
        // },
        // setIsLimite(state, payload){
        //     state.isLimite = payload;
        // },
        // setIsTemporadas(state, payload){
        //     state.isTemporadas = payload;
        // },
        // setIsEmbarcador(state, payload){
        //     state.isEmbarcador = payload;
        // },
        // setIsContenedores(state, payload){
        //     state.isContenedores = payload;
        // },
        // setIsDepositos(state, payload){
        //     state.isDepositos = payload;
        // },
        // setIsAtmosferas(state, payload){
        //     state.isAtmosferas = payload;
        // },
        // setIsTipos(state, payload){
        //     state.isTipos = payload;
        // },
        // setIsZonas(state, payload){
        //     state.isZonas = payload;
        // },
        // setIsPaises(state, payload){
        //     state.isPaises = payload;
        // },
        // setIsRegiones(state, payload){
        //     state.isRegiones = payload;
        // },
        // setIsProvincias(state, payload){
        //     state.isProvincias = payload;
        // },
        // setIsComunas(state, payload){
        //     state.isComunas = payload;
        // },
        // setIsLocalidades(state, payload){
        //     state.isLocalidades = payload;
        // },


    },
    actions: {

        // AccionCambiarIsClientes({commit}, data){
        //     commit("setIsClientes", data);
        // },
        // AccionCambiarIsUsuarios({commit}, data){
        //     commit("setIsUsuarios", data);
        // },
        // AccionCambiarIsProveedores({commit}, data){
        //     commit("setIsProveedores", data);
        // },
        // AccionCambiarIsPuertos({commit}, data){
        //     commit("setIsPuertos", data);
        // },
        // AccionCambiarIsDestinos({commit}, data){
        //     commit("setIsDestinos", data);
        // },
        // AccionCambiarIsPallets({commit}, data){
        //     commit("setIsPallets", data);
        // },
        // AccionCambiarIsCondiciones({commit}, data){
        //     commit("setIsCondiciones", data);
        // },
        // AccionCambiarIsNaves({commit}, data){
        //     commit("setIsNaves", data);
        // },
        // AccionCambiarIsNavieras({commit}, data){
        //     commit("setIsNavieras", data);
        // },
        // AccionCambiarIsLimite({commit}, data){
        //     commit("setIsLimite", data);
        // },
        // AccionCambiarIsTemporadas({commit}, data){
        //     commit("setIsTemporadas", data);
        // },
        // AccionCambiarIsEmbarcador({commit}, data){
        //     commit("setIsEmbarcador", data);
        // },
        // AccionCambiarIsContenedores({commit}, data){
        //     commit("setIsContenedores", data);
        // },
        // AccionCambiarIsDepositos({commit}, data){
        //     commit("setIsDepositos", data);
        // },
        // AccionCambiarIsAtmosferas({commit}, data){
        //     commit("setIsAtmosferas", data);
        // },
        // AccionCambiarIsTipos({commit}, data){
        //     commit("setIsTipos", data);
        // },
        // AccionCambiarIsZonas({commit}, data){
        //     commit("setIsZonas", data);
        // },
        // AccionCambiarIsPaises({commit}, data){
        //     commit("setIsPaises", data);
        // },
        // AccionCambiarIsRegiones({commit}, data){
        //     commit("setIsRegiones", data);
        // },
        // AccionCambiarIsProvincias({commit}, data){
        //     commit("setIsProvincias", data);
        // },
        // AccionCambiarIsComunas({commit}, data){
        //     commit("setIsComunas", data);
        // },
        // AccionCambiarIsLocalidades({commit}, data){
        //     commit("setIsLocalidades", data);
        // },
    
    },
};